// src/data/mock.js
// MR SWEET - GÜNCEL MENÜ

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_mrsweet-bakery/artifacts/w17xzqr1_ornekfoto.png";

export const CONTACT_INFO = {
  phone: "0542 455 59 89",
  instagram: "cafemr.sweet",
  instagramUrl: "https://instagram.com/cafemr.sweet",
  address: "Gazipaşa Mah. Ahmet Bey Sk. No: 14/1, Merkez / Bilecik",
};

export const CAMPAIGN = {
  title: "Günün Kampanyası",
  description: "Bugüne özel fırsatları kaçırmayın.",
  badge: "BUGÜNE ÖZEL",
};

export const CATEGORIES = [
  // 1 - KAHVALTILIKLAR
  {
    id: 1,
    name: "Kahvaltılıklar",
    icon: "egg",
    products: [
      {
        id: 101,
        name: "SWEET KAHVALTI",
        price: 400,
        image: "/images/menu/tekkişikkahvaltı.jpeg",
        description:
          "Beyaz Peynir, Kaşar Peyniri, Salam, Domates, Salatalık, Biber, Bal, Reçel, Siyah Zeytin, Yeşil Zeytin, Tereyağı, Kaymak, Çikolata, Sigara Böreği, Paçanga Böreği, Patates, Sosis, Yumurtalı Ekmek, Sucuklu Yumurta veya Menemen, Çerkez Peyniri ve Sınırsız Çay. Türk Kahvesi ikram.\nEkstra sıcak tabağı (1'er adet paçanga, sigara böreği, pişi ve yumurtalı ekmek): 200₺",
      },
      {
        id: 102,
        name: "SERPME KAHVALTI (2 Kişilik)",
        price: 700,
        image: "/images/menu/serpme-kahvalti-2-kisilik.jpg",
        description:
          "Beyaz Peynir, Kaşar Peyniri, Salam, Domates, Salatalık, Biber, Bal, Reçel, Siyah Zeytin, Yeşil Zeytin, Tereyağı, Kaymak, Çikolata, Sigara Böreği, Paçanga Böreği, Patates, Sosis, Yumurtalı Ekmek, Sucuklu Yumurta veya Menemen, Çerkez Peyniri ve Sınırsız Çay. Türk Kahvesi ikram.\nEkstra sıcak tabağı (1'er adet paçanga, sigara böreği, pişi ve yumurtalı ekmek): 200₺",
      },
      {
        id: 103,
        name: "KAŞARLI OMLET",
        price: 175,
        image: "/images/menu/kasarli-omlet.jpg",
        description: "",
      },
      {
        id: 104,
        name: "SUCUKLU OMLET",
        price: 175,
        image: "/images/menu/sucuklu-omlet.jpg",
        description: "",
      },
      {
        id: 105,
        name: "KARIŞIK OMLET",
        price: 175,
        image: "/images/menu/karisik-omlet.jpg",
        description: "Sucuk, Kaşar, Salam, Mantar, Mısır, Zeytin",
      },
      {
        id: 106,
        name: "MANTARLI OMLET",
        price: 175,
        image: "/images/menu/mantarli-omlet.jpg",
        description: "",
      },
      {
        id: 107,
        name: "SAHANDA YUMURTA",
        price: 120,
        image: "/images/menu/sahanda-yumurta.jpg",
        description: "",
      },
      {
        id: 108,
        name: "YUMURTA ÇEŞİTLERİ",
        price: 150,
        image: "/images/menu/sucuklu-omlet.jpg",
        description: "Kaşarlı, Sucuklu, Karışık",
      },
      {
        id: 109,
        name: "MENEMEN",
        price: 120,
        image: "/images/menu/menemen.jpg",
        description: "",
      },
      {
        id: 110,
        name: "TOSTLAR",
        price: 200,
        image: "/images/menu/tostlar.jpg",
        description:
          "Beyaz Peynirli, Kaşarlı, Sucuklu, Karışık, Sweet (Domates, Salça, Sucuk, Beyaz Peynir)",
      },
      {
        id: 111,
        name: "GÖZLEMELER",
        price: 180,
        image: "/images/menu/gozlemeler.jpg",
        description: "Peynirli, Kaşarlı, Patatesli, Kıymalı, Karışık",
      },
      {
        id: 112,
        name: "ÇİKOLATALI KREP",
        price: 250,
        image: "/images/menu/cikolatali-krep.jpg",
        description: "Belçika Çikolatası, Muz, Çilek",
      },
      {
        id: 113,
        name: "KARIŞIK KREP",
        price: 250,
        image: "/images/menu/karisik-krep.jpg",
        description: "Tavuk, Mantar, Krema, Kaşar",
      },
    ],
  },

  // 2 - BURGERLER
  {
    id: 2,
    name: "Burgerler",
    icon: "beef",
    products: [
      {
        id: 201,
        name: "Hamburger Menü (90gr)",
        price: 270,
        image: "/images/menu/hamburger-menu-90gr.jpg",
        description:
          "Hamburger Köftesi, Domates, Turşu, Patates ve Salata, İçecek",
      },
      {
        id: 202,
        name: "Chicken Burger (90gr) Menü",
        price: 240,
        image: "/images/menu/chicken-burger-menu-90gr.jpg",
        description:
          "Tavuk Köftesi, Domates, Turşu, Patates ve Salata, İçecek",
      },
      {
        id: 203,
        name: "BBQ Burger (90gr)",
        price: 270,
        image: "/images/menu/bbq-burger-90gr.jpg",
        description:
          "Hamburger Köftesi, BBQ Sos, Domates, Turşu, Patates ve Salata, İçecek",
      },
      {
        id: 204,
        name: "Cheese Burger (90gr)",
        price: 300,
        image: "/images/menu/cheese-burger-90gr.jpg",
        description:
          "Hamburger Köftesi, Cheddar Peyniri, Domates, Patates ve Salata, İçecek",
      },
      {
        id: 205,
        name: "Spanish Burger (90gr)",
        price: 330,
        image: "/images/menu/spanish-burger-90gr.jpg",
        description:
          "Hamburger Köftesi, Cheddar Peyniri, Füme Et, Domates, Patates ve Salata, İçecek",
      },
      {
        id: 206,
        name: "Sweet Burger (180gr)",
        price: 400,
        image: "/images/menu/sweet-burger-180gr.jpg",
        description:
          "Double Hamburger Köftesi, Füme Et, Cheddar Peyniri, Patates ve Salata, İçecek",
      },
      {
        id: 207,
        name: "Monster Burger (120gr)",
        price: 360,
        image: "/images/menu/monster-burger-120gr.jpg",
        description:
          "Steak House Burger, Ev Yapımı Patates Kızartması, Füme Et, Cheddar Peyniri, Patates ve Salata, İçecek",
      },
    ],
  },

  // 3 - ATIŞTIRMALIKLAR
  {
    id: 3,
    name: "Atıştırmalıklar",
    icon: "popcorn",
    products: [
      {
        id: 301,
        name: "Sosis Patates Tabağı",
        price: 170,
        image: "/images/menu/sosis-patates-tabagi.jpg",
        description: "",
      },
      {
        id: 302,
        name: "Sigara Böreği",
        price: 80,
        image: "/images/menu/sigara-boregi.jpg",
        description: "5 Adet Peynirli",
      },
      {
        id: 303,
        name: "Paçanga Böreği",
        price: 120,
        image: "/images/menu/pacanga-boregi.jpg",
        description: "5 Adet",
      },
      {
        id: 304,
        name: "Parmak Patates",
        price: 100,
        image: "/images/menu/parmak-patates.jpg",
        description: "",
      },
      {
        id: 305,
        name: "Elma Dilim Patates",
        price: 100,
        image: "/images/menu/elma-dilim-patates.jpg",
        description: "",
      },
      {
        id: 306,
        name: "Nugget",
        price: 80,
        image: "/images/menu/nugget.jpg",
        description: "5 Adet",
      },
      {
        id: 307,
        name: "Soğan Halkası",
        price: 80,
        image: "/images/menu/sogan-halkasi.jpg",
        description: "5 Adet",
      },
      {
        id: 308,
        name: "Çıtır Tavuk Parçaları",
        price: 200,
        image: "/images/menu/citir-tavuk-parcalari.jpg",
        description: "3 Adet",
      },
      {
        id: 309,
        name: "Combo Mix",
        price: 270,
        image: "/images/menu/combo-mix.jpg",
        description:
          "Nugget, Sosis, Soğan Halkası, Patates, Çıtır Tavuk",
      },
    ],
  },

  // 4 - SALATALAR
  {
    id: 4,
    name: "Salatalar",
    icon: "salad",
    products: [
      {
        id: 401,
        name: "Akdeniz Salata",
        price: 170,
        image: "/images/menu/akdeniz-salata.jpg",
        description:
          "Akdeniz Yeşillikleri, Domates, Beyaz Peynir, Kaşar Peyniri, Dilim Zeytin, Salatalık, Kruton, Özel Salata Sosu",
      },
      {
        id: 402,
        name: "Tavuklu Sezar Salata",
        price: 240,
        image: "/images/menu/tavuklu-sezar-salata.jpg",
        description:
          "Domates, Salata, Dilim Zeytin, Iceberg, Kruton, Kaşar Peyniri, Mor Lahana, Tavuk ve Özel Sos",
      },
      {
        id: 403,
        name: "Ton Balıklı Sezar Salata",
        price: 250,
        image: "/images/menu/ton-balikli-sezar-salata.jpg",
        description:
          "Domates, Salata, Dilim Zeytin, Iceberg, Kruton, Kaşar Peyniri, Mor Lahana, Ton Balığı ve Özel Sos",
      },
      {
        id: 404,
        name: "Chicken Finger Salata",
        price: 270,
        image: "/images/menu/chicken-finger-salata.jpg",
        description:
          "Domates, Salata, Dilim Zeytin, Iceberg, Kruton, Mor Lahana, Kaşar Peyniri, Chicken Finger ve Özel Sos",
      },
      {
        id: 405,
        name: "Sweet Salata",
        price: 340,
        image: "/images/menu/sweet-salata.jpg",
        description:
          "Domates, Salata, Dilim Zeytin, Iceberg, Kruton, Mor Lahana, Özel Soslu Biftek Dilimleri ve Özel Sos",
      },
    ],
  },

  // 5 - MAKARNALAR
  {
    id: 5,
    name: "Makarnalar",
    icon: "wheat",
    products: [
      {
        id: 510,
        name: "Spaghetti Napolitan",
        price: 220,
        image: "/images/menu/spaghetti-napolitan.jpg",
        description: "Spaghetti, Napolitan Sos, Kaşar Peyniri",
      },
      {
        id: 501,
        name: "Penne Arabiatta",
        price: 220,
        image: "/images/menu/penne-arabiatta.jpg",
        description: "Penne, Arabiatta Sos, Zeytin, Kaşar Peyniri",
      },
      {
        id: 502,
        name: "Spaghetti Bolognese",
        price: 250,
        image: "/images/menu/spaghetti-bolognese.jpg",
        description: "Spaghetti, Bolognese Sos, Kaşar Peyniri",
      },
      {
        id: 503,
        name: "Kremalı Tavuklu Mantarlı Penne",
        price: 250,
        image: "/images/menu/kremali-tavuklu-mantarli-penne.jpg",
        description: "Penne, Tavuk, Mantar, Krema, Kaşar Peyniri",
      },
      {
        id: 504,
        name: "Köri Soslu Penne",
        price: 250,
        image: "/images/menu/kori-soslu-penne.jpg",
        description: "Penne, Köri Sos, Tavuk Göğsü, Parmesan Peyniri",
      },
      {
        id: 505,
        name: "Mantar Tavuk Fettucini",
        price: 280,
        image: "/images/menu/mantar-tavuk-fettucini.jpg",
        description: "Fettucini, Tavuk, Mantar, Krema, Parmesan",
      },
      {
        id: 506,
        name: "Fettucini Alfredo",
        price: 320,
        image: "/images/menu/fettucini-alfredo.jpg",
        description:
          "Fettucini, Izgara Tavuk, Pastırma, Krema, Kırmızı ve Yeşil Biber, Parmesan ve Özel Sos",
      },
      {
        id: 507,
        name: "Combo Penne",
        price: 250,
        image: "/images/menu/combo-penne.jpg",
        description:
          "Penne Makarnası, Tavuk, Kıyma, Kaşar Peyniri ve Özel Salçalı Sos",
      },
      {
        id: 508,
        name: "Pizza Makarna",
        price: 250,
        image: "/images/menu/pizza-makarna.jpg",
        description: "Makarna, Parmesan",
      },
      {
        id: 509,
        name: "Penne Queso",
        price: 250,
        image: "/images/menu/penne-queso.jpg",
        description: "Penne Makarnası, Tavuk ve Özel Peynir Sosu",
      },
    ],
  },

  // 6 - TAVUK YEMEKLERİ
  {
    id: 6,
    name: "Tavuk Yemekleri",
    icon: "drumstick",
    products: [
      {
        id: 620,
        name: "Sweet Chili Soslu Tavuk",
        price: 330,
        image: "/images/menu/sweet-chili-soslu-tavuk.jpg",
        description:
          "Tavuk Göğsü, Chili Sos, Patates, Salata, Makarna",
      },
      {
        id: 621,
        name: "Köri Cheddar",
        price: 330,
        image: "/images/menu/kori-cheddar.jpg",
        description:
          "Tavuk Göğsü, Cheddar Sos, Köri Sos, Patates, Salata, Makarna",
      },
      {
        id: 622,
        name: "Gurme Tavuk",
        price: 330,
        image: "/images/menu/gurme-tavuk.jpg",
        description:
          "Tavuk Göğsü, Mantar, Arpacık Soğan, Biber, Patates, Salata, Makarna",
      },
      {
        id: 601,
        name: "Tavuk Şiş (200gr)",
        price: 330,
        image: "/images/menu/tavuk-sis-200gr.jpg",
        description:
          "Özel Soslu Göğüs, Patates Püresi, Makarna, Salata, Lavaş",
      },
      {
        id: 602,
        name: "Köri Soslu Tavuk",
        price: 330,
        image: "/images/menu/kori-soslu-tavuk.jpg",
        description: "Tavuk Eti, Köri Sos, Salata, Makarna, Patates",
      },
      {
        id: 603,
        name: "Tavuk Külbastı (200gr)",
        price: 330,
        image: "/images/menu/tavuk-kulbasti-200gr.jpg",
        description: "Özel Soslu Izgara Tavuk, Salata, Makarna, Patates",
      },
      {
        id: 604,
        name: "Tavuk Çökertme (200gr)",
        price: 330,
        image: "/images/menu/tavuk-cokertme-200gr.jpg",
        description:
          "Jülyen Doğranmış Tavuk Izgara, Ev Yapımı Patates, Yoğurt, Özel Çökertme Sosu",
      },
      {
        id: 605,
        name: "Çıtır Tavuk",
        price: 330,
        image: "/images/menu/citir-tavuk.jpg",
        description:
          "Çıtır Tavuk Parçaları, Salata, Makarna, Patates",
      },
      {
        id: 606,
        name: "Teriyaki Soslu Çıtır Tavuk",
        price: 330,
        image: "/images/menu/teriyaki-soslu-citir-tavuk.jpg",
        description:
          "Çıtır Tavuk, Teriyaki Sos, Bal, Susam, Salata, Makarna, Patates",
      },
      {
        id: 607,
        name: "BBQ Soslu Tavuk",
        price: 330,
        image: "/images/menu/bbq-soslu-tavuk.jpg",
        description:
          "BBQ Soslu Tavuk, Salata, Makarna, Patates",
      },
      {
        id: 608,
        name: "Kremalı Mantarlı Tavuk",
        price: 330,
        image: "/images/menu/kremali-mantarli-tavuk.jpg",
        description:
          "Kremalı Mantarlı Sos, Tavuk, Salata, Makarna, Patates",
      },
      {
        id: 609,
        name: "Cafe de Paris Soslu Tavuk",
        price: 330,
        image: "/images/menu/cafe-de-paris-soslu-tavuk.jpg",
        description:
          "Cafe de Paris Sos, Tavuk, Salata, Makarna, Patates",
      },
      {
        id: 610,
        name: "Kekikli Kremalı Tavuk",
        price: 330,
        image: "/images/menu/kekikli-kremali-tavuk.jpg",
        description:
          "Tavuk Göğsü, Krema, Dağ Kekiği, Sarımsak, Salata, Makarna, Patates",
      },
      {
        id: 611,
        name: "Chef Special",
        price: 330,
        image: "/images/menu/chef-special.jpg",
        description:
          "Soslu Tavuk, Arpacık Soğan, Kırmızı Biber, Yeşil Biber, Mantar, Krema, Salata, Makarna, Patates",
      },
      {
        id: 612,
        name: "Demi Glace Soslu Tavuk",
        price: 330,
        image: "/images/menu/demi-glace-soslu-tavuk.jpg",
        description:
          "Tavuk, Demi Glace Sosu, Soğan, Sarımsak, Salata, Makarna, Patates",
      },
      {
        id: 613,
        name: "Özel BBQ Soslu Tavuk",
        price: 330,
        image: "/images/menu/ozel-bbq-soslu-tavuk.jpg",
        description:
          "Pirzola Tavuk, Kırmızı Biber, Mantar, BBQ Sos, Salata, Makarna, Patates",
      },
      {
        id: 614,
        name: "Sweet Tavuk Bonfile",
        price: 330,
        image: "/images/menu/sweet-tavuk-bonfile.jpg",
        description:
          "Tavuk, Salça, Köri, Şefin Özel Acılı Sosları, Salata, Makarna, Patates",
      },
      {
        id: 615,
        name: "Tavuk Fajita",
        price: 330,
        image: "/images/menu/tavuk-fajita.jpg",
        description:
          "Soslu Tavuk, Kırmızı Biber, Yeşil Biber, Fajita Baharatları",
      },
      {
        id: 616,
        name: "Meksika Soslu Tavuk",
        price: 330,
        image: "/images/menu/meksika-soslu-tavuk.jpg",
        description:
          "Tavuk, Meksika Sosları, Kırmızı Biber, Meksika Fasulyesi, Salata, Makarna, Patates",
      },
      {
        id: 617,
        name: "Chicken Brotto",
        price: 350,
        image: "/images/menu/chicken-brotto.jpg",
        description:
          "Tavuk Göğsü, Meksika Fasulyesi, Kırmızı ve Yeşil Biber, Soğan, Mozarella, Parmesan, Özel Soslar, Kaşar ve Lavaş",
      },
      {
        id: 618,
        name: "Tavuklu Wrap",
        price: 330,
        image: "/images/menu/tavuklu-wrap.jpg",
        description:
          "Tavuk Göğsü, Kırmızı ve Yeşil Biber, Soğan, Mozarella, Parmesan, Özel Soslar, Kaşar ve Lavaş",
      },
      {
        id: 619,
        name: "QUESADILLA",
        price: 330,
        image: "/images/menu/quesadilla.jpg",
        description:
          "Tavuk Göğsü, Biber, Mısır, Soğan, Kaşar Peyniri, Cheddar Peyniri, Özel Baharat",
      },
      {
        id: 623,
        name: "KARIŞIK KREP",
        price: 330,
        image: "/images/menu/karisik-krep.jpg",
        description: "Tavuk, Mantar, Krema, Kaşar",
      },
    ],
  },

  // 7 - ET YEMEKLERİ
  {
    id: 7,
    name: "Et Yemekleri",
    icon: "flame",
    products: [
      {
        id: 701,
        name: "Soslu Izgara Köfte (200gr)",
        price: 420,
        image: "/images/menu/soslu-izgara-kofte-200gr.jpg",
        description:
          "Izgara Köfte, Özel Sos, Salata, Makarna, Patates",
      },
      {
        id: 702,
        name: "Kaşarlı Köfte (200gr)",
        price: 450,
        image: "/images/menu/kasarli-kofte-200gr.jpg",
        description:
          "Kaşarlı Izgara Köfte, Salata, Patates ve Makarna Eşliğinde",
      },
      {
        id: 703,
        name: "Sweet Köfte (200gr)",
        price: 450,
        image: "/images/menu/sweet-kofte-200gr.jpg",
        description:
          "Tortilla ile Sarılmış Fırın Köfte, Yoğurt, Salata, Makarna, Patates",
      },
      {
        id: 704,
        name: "Et Şiş (200gr)",
        price: 550,
        image: "/images/menu/et-sis-200gr.jpg",
        description:
          "Özel Soslu Antrikot, Patates Püresi, Makarna, Salata, Lavaş",
      },
      {
        id: 705,
        name: "Mushroom Steak (200gr)",
        price: 550,
        image: "/images/menu/mushroom-steak-200gr.jpg",
        description:
          "Dana Bonfile, Mantar, Krema, Salata, Makarna, Patates",
      },
      {
        id: 706,
        name: "Et Fajita (200gr)",
        price: 550,
        image: "/images/menu/et-fajita-200gr.jpg",
        description:
          "Dana Bonfile, Kırmızı Biber, Yeşil Biber, Arpacık Soğan, Fajita Baharatları",
      },
      {
        id: 707,
        name: "Dana Bonfile (200gr)",
        price: 550,
        image: "/images/menu/dana-bonfile-200gr.jpg",
        description:
          "Dana Bonfile, Demi Glace Sos, Salata, Makarna, Patates",
      },
      {
        id: 708,
        name: "Beef Brotto (200gr)",
        price: 550,
        image: "/images/menu/beef-brotto-200gr.jpg",
        description:
          "Jülyen Doğranmış Dana Bonfile, Brotto Sos, Meksika Fasulyesi, Kırmızı ve Yeşil Biber, Mozarella, Parmesan, Özel Soslar, Kaşar ve Lavaş",
      },
      {
        id: 709,
        name: "Etli Wrap (200gr)",
        price: 550,
        image: "/images/menu/etli-wrap-200gr.jpg",
        description:
          "Jülyen Doğranmış Dana Bonfile, Mısır, Kırmızı ve Yeşil Biber, Soğan, Mozarella, Parmesan, Özel Soslar, Kaşar ve Lavaş",
      },
      {
        id: 710,
        name: "Café De Paris Soslu Bonfile (200gr)",
        price: 550,
        image: "/images/menu/cafe-de-paris-soslu-bonfile-200gr.jpg",
        description:
          "Dana Bonfile, Café de Paris Sos, Salata, Makarna, Patates",
      },
      {
        id: 711,
        name: "Meksika Soslu Bonfile (200gr)",
        price: 550,
        image: "/images/menu/meksika-soslu-bonfile-200gr.jpg",
        description:
          "Dana Bonfile, Meksika Sosu, Meksika Baharatları, Meksika Fasulyesi, Salata, Makarna, Patates",
      },
      {
        id: 712,
        name: "Çökertme Kebabı (200gr)",
        price: 550,
        image: "/images/menu/cokertme-kebabi-200gr.jpg",
        description:
          "Jülyen Doğranmış Dana Bonfile, Ev Yapımı Patates, Yoğurt, Özel Çökertme Sosu",
      },
      {
        id: 713,
        name: "Beef Stroganoff (200gr)",
        price: 550,
        image: "/images/menu/beef-stroganoff-200gr.jpg",
        description:
          "Jülyen Doğranmış Dana Bonfile, Demi Glace Sos, Turşu, Salata, Makarna, Patates",
      },
      {
        id: 714,
        name: "Karışık Izgara (375gr)",
        price: 500,
        image: "/images/menu/karisik-izgara-375gr.jpg",
        description:
          "Tavuk, Köfte, Bonfile, Salata, Makarna, Patates",
      },
      {
        id: 715,
        name: "Beef Milanesa (200gr)",
        price: 550,
        image: "/images/menu/beef-milanesa-200gr.jpg",
        description:
          "Dana Bonfile, Özel Pane Harcı, Kaşar Peyniri, Salata, Makarna, Patates",
      },
      {
        id: 716,
        name: "Combo Fajita",
        price: 450,
        image: "/images/menu/combo-fajita.jpg",
        description: "",
      },
    ],
  },

  // 8 - TATLILAR
  {
    id: 8,
    name: "Tatlılar",
    icon: "cakeSlice",
    products: [
      {
        id: 801,
        name: "Waffle",
        price: 250,
        image: "/images/menu/waffle.jpg",
        description:
          "Muz, Çilek, Özel Waffle Çikolatası ve Waffle Tabanı",
      },
      {
        id: 802,
        name: "Waffle Burger",
        price: 280,
        image: "/images/menu/waffle-burger.jpg",
        description:
          "Muz, Çilek, Dondurma, Özel Waffle Çikolatası ve Waffle Tabanı",
      },
      {
        id: 803,
        name: "Belçika Çikolatalı Waffle",
        price: 280,
        image: "/images/menu/belcika-cikolatali-waffle.jpg",
        description:
          "Muz, Çilek, Özel Belçika Çikolatası ve Waffle Tabanı",
      },
      {
        id: 804,
        name: "Belçika Çikolatalı Cuplar",
        price: 300,
        image: "/images/menu/belcika-cikolatali-cuplar.jpg",
        description: "Basic Cup, Cup Of Love, Sweet Cup",
      },
      {
        id: 805,
        name: "DUBAİ CUP",
        price: 340,
        image: "/images/menu/dubai-cup.jpg",
        description:
          "Belçika Çikolatası, Antep Fıstığı, Muz, Çilek",
      },
      {
        id: 806,
        name: "Magnolia",
        price: 200,
        image: "/images/menu/magnolia.jpg",
        description:
          "Çilek, Muhallebi, Krema, Bisküvi Kırıntısı",
      },
      {
        id: 807,
        name: "Sweet Kavanoz",
        price: 200,
        image: "/images/menu/sweet-kavanoz.jpg",
        description:
          "Frambuaz Sos, Çikolatalı Kek, Kek Kırıntısı",
      },
      {
        id: 808,
        name: "Fıstık Cup",
        price: 200,
        image: "/images/menu/fistik-cup.jpg",
        description: "",
      },
      {
        id: 809,
        name: "Islak Kek",
        price: 100,
        image: "/images/menu/islak-kek.jpg",
        description: "",
      },
      {
        id: 810,
        name: "Dondurmalı Kadayıf",
        price: 170,
        image: "/images/menu/dondurmali-kadayif.jpg",
        description: "Kadayıf, Dondurma, Çikolata",
      },
      {
        id: 811,
        name: "Soğuk Baklava",
        price: 250,
        image: "/images/menu/soguk-baklava.jpg",
        description: "Porsiyon - 250gr",
      },
      {
        id: 812,
        name: "Cevizli Baklava",
        price: 200,
        image: "/images/menu/cevizli-baklava.jpg",
        description:
          "Porsiyon - 250gr (İlave Kaymak veya Dondurma 20₺)",
      },
      {
        id: 813,
        name: "Fıstıklı Baklava",
        price: 250,
        image: "/images/menu/fistikli-baklava.jpg",
        description:
          "Porsiyon - 250gr (İlave Kaymak veya Dondurma 20₺)",
      },
      {
        id: 814,
        name: "Sufle",
        price: 160,
        image: "/images/menu/sufle.jpg",
        description: "Sufle, Vanilyalı Dondurma, Krema",
      },
      {
        id: 815,
        name: "Fondü",
        price: 240,
        image: "/images/menu/fondu.jpg",
        description: "Muz, Çilek, Kivi, Sıcak Çikolata",
      },
      {
        id: 816,
        name: "Dondurma",
        price: 40,
        image: "/images/menu/dondurma.jpg",
        description:
          "Çikolatalı, Çilekli, Vanilyalı, Karamelli, Bal Badem, Oreolu",
      },
      {
        id: 817,
        name: "Lotus Frambuaz",
        price: 200,
        image: "/images/menu/lotus-frambuaz.jpg",
        description: "",
      },
      {
        id: 818,
        name: "Lotus Çilek",
        price: 200,
        image: "/images/menu/lotus-cilek.jpg",
        description: "",
      },
      {
        id: 819,
        name: "Marlenka",
        price: 200,
        image: "/images/menu/marlenka.jpg",
        description: "",
      },
      {
        id: 820,
        name: "Mozaik Pasta",
        price: 200,
        image: "/images/menu/mozaik-pasta.jpg",
        description: "",
      },
      {
        id: 821,
        name: "Çikolatalı Pasta",
        price: 200,
        image: "/images/menu/cikolatali-pasta.jpg",
        description: "",
      },
      {
        id: 822,
        name: "Frambuaz Pasta",
        price: 200,
        image: "/images/menu/frambuaz-pasta.jpg",
        description: "",
      },
      {
        id: 823,
        name: "Çilekli Pasta",
        price: 200,
        image: "/images/menu/cilekli-pasta.jpg",
        description: "",
      },
      {
        id: 824,
        name: "Çilek Şöleni",
        price: 200,
        image: "/images/menu/cilek-soleni.jpg",
        description: "",
      },
      {
        id: 825,
        name: "Fıstık Şöleni",
        price: 200,
        image: "/images/menu/fistik-soleni.jpg",
        description: "",
      },
      {
        id: 826,
        name: "Meyveli Pasta",
        price: 200,
        image: "/images/menu/meyveli-pasta.jpg",
        description: "",
      },
      {
        id: 827,
        name: "Fıstık Rüyası",
        price: 200,
        image: "/images/menu/fistik-ruyasi.jpg",
        description: "",
      },
      {
        id: 828,
        name: "Sneackers",
        price: 200,
        image: "/images/menu/sneackers.jpg",
        description: "",
      },
      {
        id: 829,
        name: "Profiterol",
        price: 200,
        image: "/images/menu/profiterol.jpg",
        description: "",
      },
      {
        id: 830,
        name: "Malaga",
        price: 200,
        image: "/images/menu/malaga.jpg",
        description: "",
      },
      {
        id: 831,
        name: "Cheesecake",
        price: 240,
        image: "/images/menu/cheesecake.jpg",
        description:
          "Frambuazlı, Limonlu ve San Sebastian",
      },
      {
        id: 832,
        name: "Trileçe",
        price: 100,
        image: "/images/menu/trilece.jpg",
        description: "Frambuazlı, Karamelli",
      },
      {
        id: 833,
        name: "Brownie",
        price: 300,
        image: "/images/menu/brownie.gif",
        description: "",
      },
      {
        id: 835,
        name: "Tiramisu",
        price: 200,
        image: "/images/menu/tiramisu.jpg",
        description: "",
      },
      {
        id: 836,
        name: "ÇİKOLATALI KREP",
        price: 250,
        image: "/images/menu/cikolatali-krep.jpg",
        description: "Belçika Çikolatası, Muz, Çilek",
      },
      {
        id: 837,
        name: "Ekler (Adet)",
        price: 40,
        image: "/images/menu/ekler-adet.jpg",
        description: "",
      },
      {
        id: 838,
        name: "Kurabiye Tabağı (200gr)",
        price: 150,
        image: "/images/menu/kurabiye-tabagi-200gr.jpg",
        description: "",
      },
      {
        id: 839,
        name: "Pistachio",
        price: 220,
        image: "/images/menu/pistachio.jpg",
        description: "",
      },
    ],
  },

  // 9 - SOĞUK İÇECEKLER
  {
    id: 9,
    name: "Soğuk İçecekler",
    icon: "glassWater",
    products: [
      { id: 901, name: "Su", price: 25, image: "/images/menu/su.jpg", description: "" },
      { id: 902, name: "Ayran", price: 50, image: "/images/menu/ayran.jpg", description: "" },
      { id: 903, name: "Coca Cola-Pepsi", price: 90, image: "/images/menu/coca-cola-pepsi.jpg", description: "" },
      { id: 904, name: "Fanta", price: 90, image: "/images/menu/fanta.jpg", description: "" },
      { id: 905, name: "Sprite", price: 90, image: "/images/menu/sprite.jpg", description: "" },
      { id: 906, name: "Ice Tea", price: 90, image: "/images/menu/ice-tea.jpg", description: "Şeftali, Limon, Mango" },
      { id: 907, name: "Cappy Meyve Suyu", price: 90, image: "/images/menu/cappy-meyve-suyu.jpg", description: "" },
      { id: 908, name: "Sade Soda", price: 60, image: "/images/menu/sade-soda.jpg", description: "" },
      { id: 909, name: "Meyveli Soda", price: 60, image: "/images/menu/meyveli-soda.jpg", description: "" },
      { id: 910, name: "Churchill", price: 80, image: "/images/menu/churchill.jpg", description: "" },
      { id: 911, name: "Red Bull", price: 130, image: "/images/menu/red-bull.jpg", description: "" },
      { id: 912, name: "Gün Batımı", price: 200, image: "/images/menu/gun-batimi.jpg", description: "Redbull Energy, Portakal Suyu, Nar Suyu" },
      { id: 913, name: "Yasak Elma", price: 200, image: "/images/menu/yasak-elma.jpg", description: "Redbull Sugar Free, Yeşil Elma Suyu, Lime" },
      { id: 914, name: "Coco Bull", price: 200, image: "/images/menu/coco-bull.jpg", description: "Redbull White Edition, Çilek, Limon" },
      { id: 915, name: "Çiçek Pasajı", price: 200, image: "/images/menu/cicek-pasaji.jpg", description: "Redbull Blue Edition, Çilek, Lime" },
      { id: 916, name: "Redbul Mojito", price: 200, image: "/images/menu/redbul-mojito.jpg", description: "Redbull Lime Edition, Lime, Nane" },
      { id: 917, name: "Sıkma Portakal Suyu", price: 100, image: "/images/menu/sikma-portakal-suyu.jpg", description: "" },
      { id: 918, name: "Limonata", price: 80, image: "/images/menu/limonata.jpg", description: "" },
      { id: 919, name: "Milk Shake", price: 140, image: "/images/menu/milk-shake.jpg", description: "Oreo, Çikolata, Çilek, Vanilya, Karamel, Mango" },
      { id: 920, name: "Frappe", price: 140, image: "/images/menu/frappe.jpg", description: "Çikolata, Çilek, Special, Vanilyalı, Brownie" },
      { id: 921, name: "Frozen", price: 140, image: "/images/menu/frozen.jpg", description: "Muz, Çilek, Kivi, Limon, Nane Limon, Mango" },
      { id: 922, name: "Smoothie", price: 140, image: "/images/menu/smoothie.jpg", description: "Muz, Çilek, Mango, Kivi, Yoğurt, Bal, Taze Meyve" },
      { id: 923, name: "Ice Latte", price: 140, image: "/images/menu/ice-latte.jpg", description: "Espresso, Buz, Süt ve Aroma" },
      { id: 924, name: "Ice Americano", price: 120, image: "/images/menu/ice-americano.jpg", description: "Espresso, Buz ve Su" },
      { id: 925, name: "Ice Mocha", price: 150, image: "/images/menu/ice-mocha.jpg", description: "Çikolata, Çilek, Karamel, Vanilya, Fındık" },
      { id: 926, name: "Ice Lotus Mocha", price: 150, image: "/images/menu/ice-lotus-mocha.jpg", description: "" },
      { id: 927, name: "Ice Flat White", price: 140, image: "/images/menu/ice-flat-white.jpg", description: "Double Espresso, Süt, Buz, Aroma" },
      { id: 928, name: "Ice Caramel Macchiatto", price: 150, image: "/images/menu/ice-caramel-macchiatto.jpg", description: "Vanilya Şurubu, Süt, Buz, Espresso, Karamel Sos" },
      { id: 929, name: "Ice Latte Macchiatto", price: 140, image: "/images/menu/ice-latte-macchiatto.jpg", description: "Süt, Buz, Espresso" },
      { id: 930, name: "Kremalı Soğuk Kahve", price: 140, image: "/images/menu/kremali-soguk-kahve.jpg", description: "Krema, Süt, Espresso, Buz" },
      { id: 931, name: "Mojito", price: 150, image: "/images/menu/mojito.jpg", description: "Taze Nane, Limon Dilimleri, Buz, Limon Aroması, Şeker Aroması ve Sprite" },
      { id: 932, name: "Long Island", price: 150, image: "/images/menu/long-island.jpg", description: "Cola, Limonata, Soğuk Çay, Limon Dilimi" },
      { id: 933, name: "İtalyan Soda", price: 100, image: "/images/menu/italyan-soda.jpg", description: "Kivi, Kavun, Turunç, Şeftali" },
      { id: 934, name: "Cinderella", price: 150, image: "/images/menu/cinderella.jpg", description: "Portakal Suyu, Çilek Aroması ve Turunç Aroması" },
      { id: 935, name: "Berry Hibiscus", price: 150, image: "/images/menu/berry-hibiscus.jpg", description: "" },
      { id: 936, name: "Cool Lime", price: 150, image: "/images/menu/cool-lime.jpg", description: "" },
    ],
  },

  // 10 - SICAK İÇECEKLER
  {
    id: 10,
    name: "Sıcak İçecekler",
    icon: "coffee",
    products: [
      { id: 1001, name: "Çay", price: 40, image: "/images/menu/cay.jpg", description: "" },
      { id: 1002, name: "Fincan Çay", price: 60, image: "/images/menu/fincan-cay.jpg", description: "" },
      { id: 1003, name: "Sahlep", price: 120, image: "/images/menu/sahlep.jpg", description: "Damla Sakızlı, Çikolatalı, Sade" },
      { id: 1004, name: "Sıcak Çikolata", price: 120, image: "/images/menu/sicak-cikolata.jpg", description: "" },
      { id: 1005, name: "Beyaz Sıcak Çikolata", price: 120, image: "/images/menu/beyaz-sicak-cikolata.jpg", description: "" },
      {
        id: 1006,
        name: "Bitki Çayları",
        price: 120,
        image: "/images/menu/bitki-caylari.jpg",
        description:
          "Papatya, Yeşil Çay, Ihlamur, Nane Limon, Elma, Kuşburnu, Adaçayı, Kış Çayı, Böğürtlen, Rezene",
      },
      {
        id: 1007,
        name: "Türk Kahveleri",
        price: 90,
        image: "/images/menu/turk-kahveleri.jpg",
        description:
          "Aromalı Türk Kahvesi, Dibek Kahvesi, Sahlepli Türk Kahvesi, Damla Sakızlı Türk Kahvesi, Menengiç Kahvesi, Mırra",
      },
      {
        id: 1008,
        name: "Filtre Kahveler",
        price: 120,
        image: "/images/menu/filtre-kahveler.jpg",
        description:
          "Sade, Guatemala, Kenya, Irish Cream, Colombia Supremo, Brazilian Santos, Swiss Choco, French Vanilla",
      },
      { id: 1009, name: "Espresso", price: 90, image: "/images/menu/espresso.jpg", description: "" },
      { id: 1010, name: "Double Espresso", price: 100, image: "/images/menu/double-espresso.jpg", description: "" },
      { id: 1011, name: "Americano", price: 120, image: "/images/menu/americano.jpg", description: "Double Espresso, Su" },
      { id: 1012, name: "Latte", price: 140, image: "/images/menu/latte.jpg", description: "One Shot Espresso, Süt" },
      { id: 1013, name: "Flat White", price: 140, image: "/images/menu/flat-white.jpg", description: "Double Espresso, Süt" },
      { id: 1014, name: "Cappucino", price: 140, image: "/images/menu/cappucino.jpg", description: "One Shot Espresso, Kadifemsi Süt" },
      { id: 1015, name: "Macchiatto", price: 140, image: "/images/menu/macchiatto.jpg", description: "Espresso, Süt, Krema, Aroma" },
      {
        id: 1016,
        name: "Mocha",
        price: 150,
        image: "/images/menu/mocha.jpg",
        description:
          "Çikolata, Espresso, Süt, Krem Şanti (Çikolatalı, Çilekli, Vanilyalı, Karamelli, Beyaz Çikolatalı)",
      },
      { id: 1017, name: "Lotus Mocha", price: 150, image: "/images/menu/lotus-mocha.jpg", description: "" },
      { id: 1018, name: "Nescafe", price: 100, image: "/images/menu/nescafe.jpg", description: "Sade, Sütlü (Ekstra 20₺)" },
      { id: 1019, name: "Double Türk Kahvesi", price: 100, image: "/images/menu/double-turk-kahvesi.jpg", description: "" },
    ],
  },
];